/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountIdsSearchRequest} from '../models/AccountIdsSearchRequest';
import type {AccountSearchRequest} from '../models/AccountSearchRequest';
import type {AccountSearchResponse} from '../models/AccountSearchResponse';
import type {Error} from '../models/Error';

export interface RunAccountIdsSearch$Request {
    accountIdsSearchRequest: AccountIdsSearchRequest;
}

export interface RunAccountIdsSearch$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const runAccountIdsSearchRequest = createAction<PayloadData<void, RunAccountIdsSearch$Request>>('RUN_ACCOUNT_SEARCH__RUN_ACCOUNT_IDS_SEARCH__REQUEST');
export const runAccountIdsSearchSuccess = createAction<PayloadData<Array<number>, RunAccountIdsSearch$Request>>('RUN_ACCOUNT_SEARCH__RUN_ACCOUNT_IDS_SEARCH__SUCCESS');
export const runAccountIdsSearchFailure = createAction<PayloadData<Error, RunAccountIdsSearch$Request, true>>('RUN_ACCOUNT_SEARCH__RUN_ACCOUNT_IDS_SEARCH__FAILURE');

export const runAccountIdsSearchActions = [
    runAccountIdsSearchRequest,
    runAccountIdsSearchSuccess,
    runAccountIdsSearchFailure
] as const;

/**
 * @param {AccountIdsSearchRequest} meta.accountIdsSearchRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const runAccountIdsSearch = (meta: RunAccountIdsSearch$Request, config?: RunAccountIdsSearch$Config) => {
    return {
        CALL_API: {
            types: runAccountIdsSearchActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/search/ids`,
            TRANSPORT_REQUEST_BODY: meta.accountIdsSearchRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RunAccountSearch$Request {
    accountSearchRequest: AccountSearchRequest;
}

export interface RunAccountSearch$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const runAccountSearchRequest = createAction<PayloadData<void, RunAccountSearch$Request>>('RUN_ACCOUNT_SEARCH__RUN_ACCOUNT_SEARCH__REQUEST');
export const runAccountSearchSuccess = createAction<PayloadData<AccountSearchResponse, RunAccountSearch$Request>>('RUN_ACCOUNT_SEARCH__RUN_ACCOUNT_SEARCH__SUCCESS');
export const runAccountSearchFailure = createAction<PayloadData<Error, RunAccountSearch$Request, true>>('RUN_ACCOUNT_SEARCH__RUN_ACCOUNT_SEARCH__FAILURE');

export const runAccountSearchActions = [
    runAccountSearchRequest,
    runAccountSearchSuccess,
    runAccountSearchFailure
] as const;

/**
 * @param {AccountSearchRequest} meta.accountSearchRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const runAccountSearch = (meta: RunAccountSearch$Request, config?: RunAccountSearch$Config) => {
    return {
        CALL_API: {
            types: runAccountSearchActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/search`,
            TRANSPORT_REQUEST_BODY: meta.accountSearchRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

